export default __webpack_public_path__ + "static/carousel-hero-android-4557e2e4f444cea958a7bdd882164db1.png";